export const nl = {
  common: {
    ok: "OK",
    cancel: "Annuleren",
    close: "Sluiten",
    copy: "Kopiëren",
    share: "Delen",
    copied: "Link gekopieerd!",
    loading: "Laden…",
    required: "Verplicht",
    optional: "optioneel",
    passwordTooShort: "Wachtwoord moet minstens 8 tekens zijn",
    cookies: "Cookies",
    privacy: "Privacybeleid",
    terms: "Voorwaarden",
    contact: "Contact",
    reportIssue: {
      title: "Probleem melden",
      descriptionLabel: "Beschrijf het probleem of idee",
      descriptionPlaceholder: "Vertel wat er mis ging of wat beter kan...",
      stepsLabel: "Stappen om te reproduceren (optioneel)",
      stepsPlaceholder: "Noem de stappen zodat wij het kunnen nalopen",
      screenshotLabel: "Screenshot (optioneel)",
      submit: "Versturen",
      error: "Oeps! Melding versturen mislukt: {{error}}",
      success: "Bedankt! We hebben je melding ontvangen.",
    },
    testimonialsTitle: "Wat anderen zeggen",
    testimonial1: "Anemi Meets bespaart me zoveel tijd! — Sophie, Rotterdam",
    freeAccountInfo:
      "Met een gratis account kun je direct Meetups plannen en uitnodigingen versturen.",
    alreadyHaveAccount: "Al een account? Inloggen",
    createAccount: "Account aanmaken",
    error_invalid_email: "Voer een geldig e-mailadres in",
    morning: "Ochtend",
    afternoon: "Middag",
    evening: "Avond",
    date: "Datum",
    cookiesFull:
      "Anemi Meets gebruikt alleen functionele cookies die nodig zijn om de site te laten werken. Door de site te gebruiken ga je akkoord met deze cookies.",
    privacyFull:
      "We verzamelen alleen de gegevens die je invult om een meetup te plannen. Deze informatie wordt nooit met derden gedeeld en alleen gebruikt voor onze dienst.",
    termsFull:
      "Door Anemi Meets te gebruiken ga je akkoord met een verantwoord gebruik van het platform. Accounts die misbruik maken kunnen worden geblokkeerd.",
    rights: "Alle rechten voorbehouden.",
    lastUpdate: "Laatst bijgewerkt:",
    contactIntro: "Stuur gerust een bericht via het onderstaande formulier.",
    contactName: "Jouw naam",
    contactEmail: "Jouw e-mailadres",
    contactMessage: "Jouw bericht",
    contactSend: "Versturen",
    contactSuccess: "Bedankt voor je bericht! We sturen je snel een reactie 😊",
    contactError: "Oeps! Er ging iets mis. Probeer het nog eens!",
    namePlaceholder: "Jouw naam",
    emailPlaceholder: "Voer je e-mailadres in",
    messagePlaceholder: "Typ hier je bericht...",
  },
  navigation: {
    home: "Home",
    explore: "Explore Cafés",
    plan: "Plan Meetup",
    dashboard: "Dashboard",
    account: "My Account",
    login: "Login",
    logout: "Logout",
  },
  home: {
    title: "Ontdek cafés & ontmoet vrienden",
    subtitle: "100% gratis · geen account nodig",
    ctaExplore: "Vind cafés",
    ctaPlan: "Plan een meetup",
    howItWorksTitle: "Hoe werkt het?",
    hiw_step1: "Kies een stad",
    hiw_step2: "Kies datums",
    hiw_step3: "Deel de link",
    testimonial: "“Afspreken is eindelijk weer makkelijk!”",
    fillIn: "Invullen",
    fillInDesc: "Laat weten wie je bent en wanneer je kunt.",
    send: "Uitnodiging versturen",
    sendDesc: "Deel de link met je vriend(in) in één klik.",
    accept: "Accepteren",
    acceptDesc: "Je vriend kiest een tijd en bevestigt. Klaar!",
    tired: "Ook klaar met eindeloze groepsapps?",
    oneClick: "Met één klik ben je klaar!",
    connectFaster: "Plan sneller, ontmoet sneller!",
    strengthen: "Versterk je connecties",
    firstStep: "Zet de eerste stap naar een echte meetup!",
    startNow: "Begin nu",
    freeText: "Nu gratis! Geen account nodig!",
  },
  createMeeting: {
    title: "Plan een meetup",
    step1_title: "Jouw gegevens",
    step1_sub: "Laat je vriend(in) weten wie uitnodigt.",
    step2_title: "Stad",
    step2_sub: "Waar wil je afspreken?",
    step3_title: "Wanneer",
    step3_sub: "Kies je beschikbare datums en tijden.",
    step4_title: "Café",
    step4_sub: "We zoeken een gezellig plekje.",
    step5_title: "Bevestigen",
    step5_sub: "Controleer en verstuur je uitnodiging.",
    btn_submit: "Uitnodiging maken",
  },
  invite: {
    titleStepCloser: "Je bent er bijna! 🎉",
    detailsHeading: "Hier zijn de details van je meetup!",
    shareInstructions:
      "Deel deze link met je vriend(in) en laat het koffie-avontuur beginnen! ☕✨",
    share: "Deel de magie! ✨",
    copyLink: "Kopieer & stuur! 📋",
    cafeInfoPending: "Café wordt snel onthuld! Stay tuned!",
    copySuccess: "Link gekopieerd! Tijd om koffiepret te verspreiden! ☕️🎉",
    copyError:
      "Oeps, kopiëren mislukt! Probeer het nog eens of roep de link gewoon door de kamer!",
    description: "Share this link so your friend can confirm.",
    copy: "Copy link",
  },
  respond: {
    title: "Je hebt een koffie-uitnodiging! ☕️🥳",
    subtitle:
      "Kies een tijd, vul je e-mail in en maak je klaar voor een gezellige meetup bij een lokaal café!",
    explanation:
      "Je vriend(in) wil samen koffie drinken bij een lokaal tentje. Kies een tijd die voor jou werkt, vul je e-mail in en wij regelen de rest. Zo steun je samen de leukste koffiezaken van de stad! ☕️❤️",
    timeLabel: "Kies een tijdslot:",
    emailLabel: "Jouw e-mailadres",
    emailPlaceholder: "jij@voorbeeld.nl",
    updatesOptIn: "Houd me op de hoogte van Anemi Meets",
    btn_confirm: "Meetup bevestigen",
    success_title: "Meetup bevestigd!",
    invalid_link: "Deze uitnodigingslink is ongeldig of verlopen.",
  },
  meetup: {
    title: "Laten we een koffiedate plannen! ☕️",
    subtitle: "Nog maar een paar stappen en je kunt uitnodigen!",
    step1: "Wie ben jij?",
    step2: "Kies een stad!",
    step3: "Kies datums",
    step4: "Kies een café",
    step5: "Klaar! 🎉",
    chooseCity: "Kies je stad",
    chooseCityInfo:
      "Kies je stad! Zo weten we waar we de leukste plekjes voor je mogen zoeken.",
    chooseDates: "Kies je datums",
    chooseTimes: "Kies je voorkeurstijden",
    chooseCafe: "Kies een café",
    summary: "Samenvatting",
    inviteLink: "Uitnodigingslink",
    copyLink: "Kopieer link",
    contactInfo: "Vertel, wie ben jij?",
    nameLabel: "Wat is jouw mooie naam? (Of een leuke bijnaam!)",
    emailLabel: "Jouw e-mailadres",
    continue: "Doorgaan",
    back: "Terug",
    submit: "Versturen",
    shuffle: "Shuffle",
    remove: "Verwijderen",
    selectedDates: "Geselecteerde datums",
    cafe: "Café",
    address: "Adres",
    successCreated: "Meetup succesvol aangemaakt!",
    errorCreating: "Er ging iets mis bij het aanmaken van de meetup",
    loadingCities: "Steden laden...",
    loadingCafes: "Cafés laden...",
    errorCitiesFetch: "Kon steden niet laden.",
    errorCafesFetch: "Kon cafés niet laden.",
    errorNameRequired: "Naam is verplicht",
    errorEmailRequired: "E-mail is verplicht",
    errorCityRequired: "Stad is verplicht",
    errorDatesRequired: "Selecteer minimaal één datum.",
    errorTimesRequired: "Selecteer minimaal één tijd.",
    errorCafeRequired: "Selecteer een café.",
    suggestionName: "Gebruik een leuke bijnaam!",
    errorNameShort: "Naam moet minstens 2 tekens zijn",
    name: "Naam",
    noCitiesAvailable:
      "Geen steden beschikbaar. Neem contact op met support of probeer het later opnieuw.",
    chooseCityLabel: "Welke stad wil je?",
    chooseCafeInfo: "Shuffle voor een verrassingscafé!",
    noCafeMatch: "Oeps! We konden geen café vinden dat bij jouw voorkeuren past. Probeer je filters te versoepelen, of kies gewoon lekker een willekeurige plek! ☕️✨",
  },
  dashboard: {
    title: "Jouw Dashboard",
    welcome: "Hoi daar",
    user: "vriend",
    lastLogin: "Laatst gezien: {{date}}",
    lastActivity: "Laatste gezellige meetup:",
    upcomingMeetups: "Jouw volgende meetups",
    noMeetups: "Nog geen meetups. Tijd om iets leuks te plannen! ☕️🎉",
    ctaNewMeetup: "Plan iets nieuws!",
    ctaProfile: "Profiel bewerken",
    ctaLogout: "Uitloggen",
    errorLoadingMeetups:
      "Oeps, je meetups laden lukt niet. Probeer het straks nog eens!",
    searchFriends: "Vrienden zoeken",
  },
  account: {
    title: "Jouw Profiel",
    profileInfo: "Over jou",
    name: "Naam",
    email: "E-mail",
    emoji: "Kies je vibe",
    age: "Hoe oud ben je?",
    edit: "Bewerken",
    save: "Opslaan",
    cancel: "Annuleren",
    changeName: "Naam veranderen",
    changeEmail: "E-mail veranderen",
    nameEditHint: "Toffe naam? Pas hem hier aan!",
    emailEditHint: "Verkeerd e-mailadres? Fix het hier!",
    ageEditHint: "Hoe jong voel je je? Typ het in!",
    wantsUpdates: "Stuur me leuke updates!",
    wantsUpdatesCheckbox: "Ja, ik wil updates ontvangen!",
    wantsReminders: "Stuur me herinneringen voor meetups",
    wantsRemindersCheckbox: "Ja, herinner me per e-mail!",
    wantsNotifications: "Browser notificaties",
    wantsNotificationsCheckbox: "Ja, stuur meldingen in mijn browser!",
    isPrivate: "Houd mijn profiel privé",
    isPrivateCheckbox: "Ja, ik wil mijn profiel privé houden!",
    dangerZone: "Gevaarzone",
    deleteAccount: "Verwijder mijn account",
    deleteConfirm: "Weet je het zeker? Dit kun je niet meer terugdraaien!",
    confirmDelete: "Ja, alles verwijderen",
    logout: "Uitloggen",
    saving: "Opslaan...",
    notSpecified: "Nog niet ingevuld",
    errorSession: "Oeps, er ging iets mis. Log opnieuw in!",
    status: {
      confirmed: "Bevestigd",
      pending: "In afwachting",
      cancelled: "Geannuleerd",
      declined: "Geweigerd",
    },
    contactPerson: "Contactpersoon",
    unknownContact: "Onbekende contactpersoon",
    password: "Wachtwoord veranderen",
    changePassword: "Wachtwoord bijwerken",
    currentPassword: "Huidig wachtwoord",
    newPassword: "Nieuw wachtwoord",
    confirmPassword: "Bevestig nieuw wachtwoord",
    passwordChangeSuccess: "Wachtwoord succesvol gewijzigd!",
    myMeetups: "Jouw meetups (lekker sociaal!)",
    errorLoadingMeetupsDetails:
      "Oeps! Je meetups laden niet. Probeer het opnieuw of ververs de pagina.",
    pastMeetups: "Afgelopen meetups",
    personalInvite: "Jouw persoonlijke uitnodigingslink",
    copyInvite: "Kopieer link",
    inviteHint:
      "Deel deze link met vrienden zodat ze direct met je kunnen verbinden!",
    yourBadges: "Jouw badges",
    locked: "Vergrendeld",
  },
  toast: {
    profileUpdated: "Profiel bijgewerkt!",
    signupSuccess: "Account aangemaakt! Alles is geregeld! ✨",
  },
  sessionExpiresSoon: "Je sessie verloopt bijna. Log opnieuw in.",

  login: {
    title: "Welkom terug! 👋",
    subtitle: "Klaar voor meer koffie-avonturen? Log hieronder in!",
    welcomeBack: "Welkom terug",
    welcomeDesc: "Fijn je weer te zien! Log in om verder te gaan.",
    forgotPassword: "Wachtwoord vergeten? Oeps!",
    noAccountCta: "Nog geen account? Doe gezellig mee!",
    error_generic: "Hmm, dat ging niet goed. Probeer het nog eens?",
    error_user_not_found:
      "We kunnen dat e-mailadres niet vinden. Klopt het wel?",
    error_invalid_password:
      "Die combinatie klopt niet helemaal. Nog een keer proberen!",
    error_invalid_email: "Dat e-mailadres lijkt niet te kloppen. Even checken?",
    error_user_banned:
      "Dit account is geblokkeerd. Hulp nodig? Neem contact op!",
    error_email_not_confirmed: "Check je inbox om je e-mail te bevestigen!",
    errorRateLimit:
      "Wow, even rustig aan! Je hebt te vaak geprobeerd. Wacht een momentje.",
    reset_error_generic: "Kon de resetmail niet sturen. Probeer het nog eens?",
    reset_success: "Resetmail verstuurd! Tijd voor een nieuw wachtwoord en verse koffie ☕️. Check je inbox!",
    toast: {
      loginSuccess: "Yes, je bent binnen! 🎉",
    },
    emailPlaceholder: "Jouw e-mailadres",
    emailLabel: "Jouw e-mailadres",
    passwordLabel: "Jouw wachtwoord",
    passwordPlaceholder: "Je geheime wachtwoord",
    loginButton: "Laat me binnen!",
    googleButton: "Inloggen met Google",
  },
  signup: {
    title: "Registreren",
    subtitle: "Maak gratis je account aan om te beginnen",
    namePrompt: "Leuk dat je er bent! Hoe mogen we je noemen?",
    namePlaceholder: "Jouw naam",
    emailPrompt: "Op welk e-mailadres kunnen we je bereiken?",
    emailPlaceholder: "Jouw e-mailadres",
    passwordPrompt: "Welk wachtwoord wil je gebruiken voor dit account?",
    passwordPlaceholder: "Jouw wachtwoord",
    confirmPasswordPrompt:
      "Sorry, maar we moeten even checken of je je wachtwoord goed hebt getypt",
    confirmPasswordPlaceholder: "Bevestig je wachtwoord",
    overviewTitle: "Overzicht van je gegevens",
    submit: "Registreren",
    steps: ["Naam", "E-mail", "Wachtwoord", "Overzicht"],
  },
  onboarding: {
    welcome: {
      title: "Welkom bij Anemi Meets!",
      description:
        "Plan meetups met vrienden in een paar klikken. We laten je zien hoe het werkt!",
    },
    features: {
      title: "Makkelijk plannen",
      description:
        "Kies een stad, een datum en nodig je vrienden uit. Wij regelen de rest!",
    },
    getting_started: {
      title: "Aan de slag",
      description: "Klaar om je eerste meetup te maken? Let's go!",
    },
  },
  skip: "Overslaan",
  get_started: "Aan de slag! 🚀",
  next: "Volgende",
  createMeetup: {
    chooseCity: "Kies je stad",
    chooseCityInfo:
      "Kies je stad! Zo weten we waar we de leukste plekjes voor je mogen zoeken.",
    chooseCityLabel: "Welke stad wil je?",
    chooseDaysInfo:
      "Kies zoveel dagen als je wilt! Hoe meer, hoe gezelliger ☀️",
    chooseDates: "Kies je datums",
    chooseTimes: "Kies je voorkeurstijden voor elke datum",
    chooseCafe: "Kies je café!",
    summary: "Samenvatting",
    name: "Naam",
    city: "Stad",
    cafe: "Café",
    selectedDates: "Geselecteerde datums",
    errorNameShort: "Naam moet minstens 2 tekens zijn",
    errorEmailInvalid: "Voer een geldig e-mailadres in",
    errorEmailRequired: "E-mail is verplicht",
    errorNameRequired: "Naam is verplicht",
    errorCityRequired: "Stad is verplicht",
    errorDatesRequired: "Selecteer minimaal één datum.",
    errorTimesRequired: "Selecteer minimaal één tijd.",
    errorCafeRequired: "Selecteer een café.",
    suggestionName: "Gebruik een leuke bijnaam!",
  },
};
